var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"DsnPanel"},[_c('el-card',{staticClass:"box-card",attrs:{"shadow":"never"}},[_c('template',{slot:"header"},[_c('div',{staticClass:"header"},[_vm._t("header")],2)]),_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }